import { sizeTab, texto, a11yProps, hasPermission, ROUTER_PATHS,  } from "@/shared";
// gridSizeMdLg12,useUploadFile 
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab, Grid,  } from "@mui/material";
// Button,
import { useState } from "react";
import SolicitudPedidoTable from "../shared/componente/SolicitudPedidoTable";
import { EstadosSolicitudPeodidoEnum } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import {getEnvs} from "@/shared"

//const returnUrl = '/compras/solicitudes-pedidos';
const returnUrl = ROUTER_PATHS.pedidos.solicitud_pedidos_nav

export default function SolicitudPedidosPagina() {

  const [valueTab, setValueTab] = useState(0);
  //
  // const {
  //   VITE_API_URL_AWS, 
  //   VITE_BUCKET_BASE
  // }=getEnvs()
  // const {
  //   fileInputRef,
  //   handleImportPedido,
  //   descargarExcelUrl
  // } = useUploadFile()
  // console.log(handleImportPedido)

  // const handleCargaMasiva = () => {
  //   fileInputRef.current?.click()
  // }
  // const handleDescargarPlantilla = () => {
  //   descargarExcelUrl(
  //     `${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}/excel/plantilla_solicitud_pedido.xlsx`,
  //     'plantilla_solicitud_pedido.xlsx'
  //   )

  // }

  return (

    <SingleTableBoxScene title={"Solicitud de Pedido"} urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_solicitudegreso)}>
      <Grid container spacing={2} sx={{ display: 'flex', gap: 1, mb: 2 }}>

        {/* <Button
          variant="text"
          startIcon={<CloudUploadIcon />}
          onClick={handleCargaMasiva}

        >
          Carga masiva
        </Button>
        <input
          type="file"
          hidden accept=".xls, .xlsx"
          ref={fileInputRef}
          onChange={handleImportPedido}
        />
        <Button
          variant="text"
          startIcon={<CloudDownloadIcon />}
          onClick={handleDescargarPlantilla}
        >
          Descargar Plantilla
        </Button> */}
      </Grid>

      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.solicitud_pedido_espera} {...a11yProps(0)} />
          <Tab label={texto.solicitudes_pedido_aprobadas} {...a11yProps(1)} />
          <Tab label={texto.solicitud_pedido_rechazada} {...a11yProps(2)} />
          {/* <Tab label={texto.solicitud_pedido_rechazada_parcialmente} {...a11yProps(3)} /> */}

        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudPedidoTable estado={EstadosSolicitudPeodidoEnum.ESPERA} action={true} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudPedidoTable estado={EstadosSolicitudPeodidoEnum.APROBADAS} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudPedidoTable estado={EstadosSolicitudPeodidoEnum.RECHAZADO} />
      </CustomTabPanel>
      {/* <CustomTabPanel value={valueTab} index={3}>
        <SolicitudPedidoTable estado={EstadosSolicitudPeodidoEnum.RECHAZADO} tiene_rechazo={true} />
      </CustomTabPanel> */}


    </SingleTableBoxScene>
  );


}


